var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import { gql } from '@apollo/client';
gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fragment resourceIdentifier on ResourceIdentifier {\n    id\n    type\n  }\n"], ["\n  fragment resourceIdentifier on ResourceIdentifier {\n    id\n    type\n  }\n"])));
var entityDefaults = {
    context: {}
};
var EntityContext = React.createContext(entityDefaults);
/**
 * Provider component for entity context to the React tree.
 */
export var EntityContextProvider = function (props) {
    return React.createElement(EntityContext.Provider, { value: props.EntityContext || entityDefaults }, props.children || null);
};
EntityContextProvider.displayName = 'EntityContextProvider';
export var useEntityContext = function (domainName) {
    var entityContext = React.useContext(EntityContext);
    var domainSummary = entityContext.context[domainName];
    return domainSummary ? domainSummary : { id: null, type: null };
};
var templateObject_1;
//# sourceMappingURL=entity-context.js.map